import {ACTION_TYPE} from '../../core/redux/actionType';
import {IAppState} from '../../core/redux/IAppState';
import {assoc} from '../../language/module';
import { ResortToolsConfig } from './resortToolsConfig';


type DefaultConfigAction = {
  type: ACTION_TYPE.DEFAULT_CONFIG;
  resortToolsConfig: ResortToolsConfig;
}

export const defaultConfigAction = (resortToolsConfig: ResortToolsConfig): DefaultConfigAction  => ({
  type: ACTION_TYPE.DEFAULT_CONFIG,
  resortToolsConfig: resortToolsConfig,
})

export const defaultConfigReducer = (state: IAppState, action: DefaultConfigAction): IAppState => {
  if (action.type !== ACTION_TYPE.DEFAULT_CONFIG) {
    return state;
  }

  return assoc(
    'resortToolsConfig',
    action.resortToolsConfig,
    state,
  )
}